import { Component, OnInit } from '@angular/core';
import { DataService } from '../../../../../../services/commande-client/data.service';

@Component({
  selector: 'app-consolidation-facture',
  templateUrl: './consolidation-facture.component.html',
  styleUrls: ['./consolidation-facture.component.scss']
})
export class ConsolidationFactureComponent implements OnInit {

  constructor(private dataService: DataService) {}

  ngOnInit(): void {
    // Pas un statut de paiement : on charge toutes les factures, le filtre
    // « liée à des tickets de caisse » est appliqué dans shared.
    this.dataService.filterFactureByStatus('Tous');
  }
}
